<div
  class="data-forwarder-chips-cell"
  (click)="onClickShowMore()"
  [ngClass]="{ open: showMore }"
  [class.data-forwarder-chips-cell-compact-Mode]="isCompactModeActivated()"
>
  <div class="example-chip-list">
    <mat-chip-grid #chipList aria-label="Data forwarder">
      <div class="display-block" [ngClass]="{ open: showMore }">
        @for (
          item of selectedDataForwarders();
          let i = $index;
          track item.destinationEmailAddress
        ) {
          @if (showMore || i < 1) {
            <mat-chip-row
              class="example-chip-list__chip"
              [matTooltip]="item.destinationEmailAddress"
              (removed)="onRemoveRule(item)"
            >
              {{
                item.destinationEmailAddress?.length > 8
                  ? (item.destinationEmailAddress | slice: 0 : 5) + '...'
                  : item.destinationEmailAddress
              }}
              @if (showMore && !readonly()) {
                <button matChipRemove>
                  <mat-icon class="example-chip-list__delete">cancel</mat-icon>
                </button>
              }
            </mat-chip-row>
          }
        }
        @if (!showMore && selectedDataForwarders()?.length > 1) {
          <mat-chip-row class="example-chip-list__chip">
            +{{ selectedDataForwarders()?.length - 1 }}
          </mat-chip-row>
        }
      </div>
      <div class="example-chip-list__input-container">
        <input
          class="example-chip-list__input"
          [ngClass]="{ hidden: !showMore || readonly() }"
          #input
          placeholder="Add Data Forwarding"
          [formControl]="formControl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)"
        />
        @if (showMore && !readonly()) {
          <button
            mat-icon-button
            (click)="addButton()"
            [disabled]="!formControl.value || formControl.invalid"
            matTooltip="Add"
          >
            <mat-icon>add_box</mat-icon>
          </button>
        }
      </div>
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (address of filteredDataForwarders(); track address.destinationEmailAddress) {
        <mat-option [value]="address">
          {{ address.destinationEmailAddress }}
        </mat-option>
      }
    </mat-autocomplete>
  </div>
  @if (showMore) {
    <button
      class="data-forwarder-chips-cell__show-less"
      mat-icon-button
      matTooltip="Close"
      (click)="onClickShowLess($event)"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
